import { amazonpayConstants } from "./amazonpay.constants";

export function amazonPay(state = {}, action) {
    let configs;
    let i;
    switch (action.type) {
        case amazonpayConstants.GET_AMAZONPAY_CONFIGURATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                configurations: null,
            };

        case amazonpayConstants.GET_AMAZONPAY_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: action.result,
                errorMessage: null,
                loadMigrationModal: true,
            };

        case amazonpayConstants.GET_AMAZONPAY_CONFIGURATIONS_FAILURE:
            return {
                ...state,
                configurations: null,
                errorMessage: action.errorMessage,
                loading: false,
            };

        case amazonpayConstants.ADD_AMAZONPAY_CONFIGURATION_REQUEST:
            return {
                ...state,
                subloading: true,
                modalErrorMessage: null,
            };

        case amazonpayConstants.ADD_AMAZONPAY_CONFIGURATION_SUCCESS:
            configs = state.configurations;
            configs.push(action.result);
            return {
                ...state,
                subloading: false,
                configurations: configs,
                modalErrorMessage: null,
                editModal: false,
            };

        case amazonpayConstants.ADD_AMAZONPAY_CONFIGURATION_FAILURE:
            return {
                ...state,
                modalErrorMessage: action.errorMessage,
                subloading: false,
            };

        case amazonpayConstants.UPDATE_AMAZONPAY_CONFIGURATION_REQUEST:
            return {
                ...state,
                subloading: true,
                modalErrorMessage: null,
                infoMessage: null,
            };

        case amazonpayConstants.UPDATE_AMAZONPAY_CONFIGURATION_SUCCESS:
            let configurations = state.configurations;
            let index = configurations.findIndex((item) => {
                return item.externalUUID === action.configuration.externalUUID;
            });
            if (index < 0) {
                configurations.push(action.configuration);
            } else {
                configurations[index] = action.configuration;
            }
            return {
                ...state,
                subloading: false,
                configuration: action.configuration,
                infoMessage: "Speichern erfolgreich.",
                editModal: false,
                configurations: configurations,
            };

        case amazonpayConstants.UPDATE_AMAZONPAY_CONFIGURATION_FAILURE:
            return {
                ...state,
                subloading: false,
                modalErrorMessage: action.errorMessage,
                infoMessage: null,
            };

        case amazonpayConstants.DELETE_AMAZONPAY_CONFIGURATION_REQUEST:
            return {
                ...state,
                subloading: true,
                modalErrorMessage: null,
            };

        case amazonpayConstants.DELETE_AMAZONPAY_CONFIGURATION_SUCCESS:
            configs = state.configurations;
            i = configs.findIndex((item) => {
                return item.externalUUID === action.result.externalUUID;
            });
            configs.splice(i, 1);
            return {
                ...state,
                subloading: false,
                configurations: configs,
                deletionModal: false,
                modalErrorMessage: null,
            };

        case amazonpayConstants.DELETE_AMAZONPAY_CONFIGURATION_FAILURE:
            return {
                ...state,
                modalErrorMessage: action.errorMessage,
                subloading: false,
            };

        case amazonpayConstants.TOGGLE_DELETE_CONFIGURATION_MODAL:
            return {
                ...state,
                configurationToDelete: action.configuration,
                deletionModal: !state.deletionModal,
                modalErrorMessage: null,
            };

        case amazonpayConstants.TOGGLE_EDIT_CONFIGURATION_MODAL:
            return {
                ...state,
                editModal: !state.editModal,
                infoMessage: null,
                modalErrorMessage: null,
            };

        case amazonpayConstants.TOGGLE_AMAZONPAY_IMPORT_MODAL:
            return {
                ...state,
                importId: action.itemId ? action.itemId : state.importId,
                warningMessages: null,
                modalErrorMessage: null,
                imported: false,
                importModal: !state.importModal,
            };

        case amazonpayConstants.UPLOAD_AMAZONPAY_DATA_FILE_REQUEST:
            return {
                ...state,
                submitted: true,
                importLoading: true,
                modalErrorMessage: null,
            };

        case amazonpayConstants.UPLOAD_AMAZONPAY_DATA_FILE_SUCCESS:
            let config = action.result;
            configs = state.configurations;
            index = configs.findIndex((item) => {
                return item.externalUUID === config.externalUUID;
            });
            if (index > -1) {
                configs[index] = config;
            } else {
                configs.unshift(config);
            }
            return {
                ...state,
                importLoading: false,
                imported: true,
                configurations: configs,
            };

        case amazonpayConstants.UPLOAD_AMAZONPAY_DATA_FILE_FAILURE:
            return {
                ...state,
                importLoading: false,
                imported: false,
                modalErrorMessage: action.errorMessage,
            };

        case amazonpayConstants.RESET_STATE:
            return {};

        case amazonpayConstants.MIGRATE_CONFIGURATION_TO_V2_REQUEST:
            return {
                ...state,
                subloading: true,
                migrationErrorMessage: null,
                migrationSuccessMessage: null,
            };

        case amazonpayConstants.MIGRATE_CONFIGURATION_TO_V2_SUCCESS:
            return {
                ...state,
                subloading: false,
                configurations: configs,
                deletionModal: false,
                migrationSuccessMessage: action.result.successMessage,
            };

        case amazonpayConstants.MIGRATE_CONFIGURATION_TO_V2_FAILURE:
            return {
                ...state,
                migrationErrorMessage: action.errorMessage,
                subloading: false,
            };

        case amazonpayConstants.LOAD_AMAZONPAY_MIGRATION_MODAL:
            return {
                ...state,
                loadMigrationModal: true,
            };

        case amazonpayConstants.SET_CONFIGURATION_AND_CLIENT_TO_MIGRATE:
            return {
                ...state,
                configurationToMigrate: action.payload.configuration,
                clientToMigrate: action.payload.client,
                hasAuthData: action.payload.hasAuthData,
                migrationMessage: action.payload.hasAuthData
                    ? 'Eine Verbindung zu Amazon Pay wurde gefunden. Das Update wird automatisch nach dem Klick auf "Integration aktualisieren" durchgeführt.'
                    : 'Hinweis: In diesem <a href="https://developer.amazon.com/de/docs/amazon-pay-checkout/get-set-up-for-integration.html#5-get-your-public-key-id" target="_blank" rel="noopener noreferrer"> ' +
                      " Wissensartikel</a> findest du eine Anleitung wie du den Public Key bei Amazon erhältst. Bitte beachte, " +
                      "dass du den Public Key für <b>Amazon Pay (Production View)</b> benötigst. Wenn du den Public Key und die .pem Datei hochgeladen hast, " +
                      "updaten wir automatisch deine Amazon Pay Integration. ",
            };

        case amazonpayConstants.SET_TRANSIT_ACCOUNT_MESSAGE:
            return {
                ...state,
                transitAccountMessage:
                    "Warnung: in einem Deiner Setups konnten wir kein Transitkonto finden. Bitte vor dem Update ausfüllen (Pflichtfeld) oder das vorgeschlagene Konto akzeptieren",
            };

        case amazonpayConstants.SET_HOLDING_ACCOUNT_MESSAGE:
            return {
                ...state,
                holdingAccountMessage:
                    "Warnung: in einem Deinem Setups konnten wir kein Reserve- und Einbehaltekonto finden. Wir empfehlen dir das Konto vor dem Update auszufüllen oder das vorgeschlagene Konto akzeptieren",
            };

        case amazonpayConstants.UPDATE_VALUE_ON_CONFIGURATION:
            let configuration = action.payload.configuration;
            configuration = { ...configuration, [action.payload.name]: action.payload.value };

            configs = state.configurations;
            index = configs.findIndex((item) => {
                return item.externalUUID === configuration.externalUUID;
            });
            configs[index] = config;

            return {
                ...state,
                configurations: configs,
            };

        default:
            return state;
    }
}
